import oneOneSchema from "./oneOneSchema";
import oneTwoSchema from "./oneTwoSchema";
import oneThreeSchema from "./oneThreeSchema";
import oneFourSchema from "./oneFourSchema";
import oneFiveSchema from "./oneFiveSchema";
import twoOneSchema from "./twoOneSchema";
import twoTwoSchema from "./twoTwoSchema";
import threeOneSchema from "./threeOneSchema";
import threeTwoSchema from "./threetwoSchema";
import threeThreeSchema from "./threeThreeShema";
import threeFourSchema from "./threeFourSchema";
import threeFiveSchema from "./threeFiveSchema";
import fourOneSchema from "./fourOneSchema";
import fourTwoSchema from "./fourTwoSchema";
import fourThreeSchema from "./fourThreeSchema";
import fourFourSchema from "./fourFourSchema";
import fourFiveSchema from "./fourFiveSchema";
import fiveOneSchema from "./fiveOneSchema";
import fiveTwoSchema from "./fiveTwoSchema";
import fiveThreeSchema from "./fiveThreeSchema";
import fiveFourSchema from "./fiveFourSchema";
import sixOneSchema from "./sixOneSchema";
export const BASEEASchemas = {
  "1.1 Stationary Combustion": oneOneSchema,
  "1.2 Mobile Combustion": oneTwoSchema,
  "1.3 Industrial Processes": oneThreeSchema,
  "1.4 Fugitive Emissions": oneFourSchema,
  "1.5 Land Use, Land Use Change and Forestry (LULUCF)": oneFiveSchema,
  "2.1 Imported Electricity": twoOneSchema,
  "2.2 Imported Energy": twoTwoSchema,
  "3.1 Upstream Transport and Distribution for Goods": threeOneSchema,
  "3.2 Downstream Transport and Distribution for Goods": threeTwoSchema,
  "3.3 Employee Commuting": threeThreeSchema,
  "3.4 Client and Visitor Transport": threeFourSchema,
  "3.5 Business Travel": threeFiveSchema,
  "4.1 Goods Purchased by an Organization": fourOneSchema,
  "4.2 Capital Goods that are Purchased and Amortized by an Organization":
    fourTwoSchema,
  "4.3 Disposal Services (of solid or liquid waste) Used by an Organization":
    fourThreeSchema,
  "4.4 Use of Assets (through leased equipment) by an Organization":
    fourFourSchema,
  "4.5 Use of Services not Described in the above sub-categories by an Organization":
    fourFiveSchema,
  "5.1 Use Stage of the Product": fiveOneSchema,
  "5.2 Downstream Leased Assets": fiveTwoSchema,
  "5.3 End of Life Stage of the Product": fiveThreeSchema,
  "5.4 Investments": fiveFourSchema,
  "6.1 Indirect GHG Emissions from other sources": sixOneSchema,
};
